module.exports = __webpack_public_path__ + "media/img/frontend_application/coupon-purple-ebd8a1726f7e2dfc502d2d58beae0456.png";